// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "_" + "49116c7f875bbd5c" + ".css";
};